/**
 * RevWorks — Detailing Services page: mobile service-card carousels.
 *
 * Shared by sections/rw-page-detailing-cleaning.liquid, sections/
 * rw-page-detailing-exterior.liquid and sections/
 * rw-page-detailing-specialist.liquid (and reusable by a future Phase 5
 * Paint Correction section) via a plain <script src> tag in each,
 * rather than duplicating this behaviour as a separate {% javascript %}
 * block per section. Every entry point below is written to run safely
 * no matter how many of those <script> tags load it on the same page.
 *
 * Two independent jobs:
 *  1. Dot-tracking + click-to-scroll for each [data-rw-detailing-carousel]
 *     track (mobile-only in practice, since the track is a normal CSS
 *     grid above 699px and nothing here assumes otherwise).
 *  2. Keeping every shared service card's native <details> open on
 *     mobile and interactive (closed by default) at tablet/desktop —
 *     done by actually toggling the `open` attribute in sync with the
 *     breakpoint, not by forcing visibility with CSS while the element
 *     stays semantically closed.
 */
(function () {
  var mobileQuery = window.matchMedia('(max-width: 699px)');

  document.addEventListener('shopify:section:load', function (event) {
    initCarousels(event.target);
    syncDisclosure(mobileQuery.matches);
  });

  initCarousels(document);
  syncDisclosure(mobileQuery.matches);
  attachDisclosureListener();

  function initCarousels(scope) {
    var tracks = scope.querySelectorAll('[data-rw-detailing-carousel]');
    tracks.forEach(function (track) {
      if (track.hasAttribute('data-rw-detailing-carousel-inited')) return;
      track.setAttribute('data-rw-detailing-carousel-inited', '');
      initTrack(track);
    });
  }

  function initTrack(track) {
    var cards = Array.prototype.slice.call(track.querySelectorAll('.rw-detailing-card'));
    if (!cards.length) return;

    var nav = track.parentElement
      ? track.parentElement.querySelector('[data-rw-detailing-carousel-dots]')
      : null;
    var dots = nav
      ? Array.prototype.slice.call(nav.querySelectorAll('[data-rw-detailing-carousel-dot]'))
      : [];
    if (!dots.length) return;

    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var card = cards[i];
        if (!card) return;
        card.scrollIntoView({
          behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      });
    });

    if (!window.IntersectionObserver) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.6) {
            var index = cards.indexOf(entry.target);
            if (index !== -1) setActive(index);
          }
        });
      },
      { root: track, threshold: [0.6] }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function syncDisclosure(isMobile) {
    var detailsEls = document.querySelectorAll('.rw-detailing-card__details');
    detailsEls.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (isMobile) {
        details.open = true;
        if (summary) summary.tabIndex = -1;
      } else {
        details.open = false;
        if (summary) summary.removeAttribute('tabindex');
      }
    });
  }

  function attachDisclosureListener() {
    if (document.documentElement.hasAttribute('data-rw-detailing-disclosure-inited')) return;
    document.documentElement.setAttribute('data-rw-detailing-disclosure-inited', '');

    function handleChange(event) {
      syncDisclosure(event.matches);
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleChange);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(handleChange);
    }
  }
})();
